import { IConditionalStyle } from "./conditional-style";
import { IFillStyle } from "./fill-style";
import { IStylingBorder } from "./styling-border";
import { IStylingEffects } from "./styling-effects";
import { IStylingPosition } from "./styling-position";
import { IStylingShadow } from "./styling-shadow";
import { IStylingTypography } from "./styling-typography";

export interface IKuikaStyle {
  border?: IStylingBorder;
  shadow?: IStylingShadow;
  fill?: IFillStyle;
  position?: IStylingPosition;
  text?: IStylingTypography;
  effects?: IStylingEffects;
  /**
   * KOA-9069: style overlays chosen by a data condition rather than by a pseudo-state.
   * Optional and absent by default — a screen saved before this feature deserialises
   * unchanged and emits byte-identical code.
   */
  conditionalStyles?: IConditionalStyle[];
  autoIncrementedIndex?: number;
  styleGroupId?: string | null; // Links all 6 style parts together
  styleGroupName?: string; // The unified style name for display
}

export enum EColorPickerTab {
  Solid = "solid",
  Gradient = "gradient",
  Image = "image",
  AI = "ai"
}
